import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { History, Lock, Unlock } from 'lucide-react';

const API = `${window.__BACKEND_URL__}/api`;

const when = (iso) => {
  try { return new Date(iso).toLocaleString(undefined, { month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit' }); }
  catch { return iso; }
};

// Payroll Review timeline: who locked / unlocked this pay period, when and why.
export const LockHistory = ({ token, period, refreshKey }) => {
  const [events, setEvents] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!period.start || !period.end) return;
    axios.get(`${API}/payroll/lock-history`, { headers: { Authorization: `Bearer ${token}` }, params: { start_date: period.start, end_date: period.end } })
      .then((r) => setEvents(r.data.events || []))
      .catch(() => setEvents([]));
  }, [token, period.start, period.end, refreshKey]);

  if (!events || events.length === 0) return null;
  const latest = events[0];

  return (
    <div className="ht-card p-3" data-testid="lock-history">
      <button type="button" onClick={() => setOpen((o) => !o)} className="w-full flex items-center justify-between gap-3 text-left" data-testid="lock-history-toggle">
        <span className="text-sm text-white flex items-center gap-2">
          <History className="w-4 h-4 text-slate-400" /> Lock history
          <span className="text-[11px] px-1.5 py-0.5 rounded-full bg-[#0F1923] border border-[#1F2D3F] text-slate-300" data-testid="lock-history-count">{events.length}</span>
        </span>
        <span className="text-xs text-slate-400 truncate">
          Latest: {latest.action === 'locked' ? 'Locked' : 'Unlocked'} by {latest.by_name} · {when(latest.at)}{latest.reason ? ` — "${latest.reason}"` : ''}
          <span className="ml-2 text-slate-500">{open ? 'Hide' : 'Show'}</span>
        </span>
      </button>
      {open && (
        <ol className="mt-3 space-y-2 border-l border-[#1F2D3F] ml-2 pl-4" data-testid="lock-history-list">
          {events.map((e) => (
            <li key={e.id} className="relative text-xs" data-testid={`lock-history-event-${e.id}`}>
              <span className={`absolute -left-[22px] top-0.5 w-3 h-3 rounded-full flex items-center justify-center ${e.action === 'locked' ? 'bg-emerald-500/20 text-emerald-300' : 'bg-amber-500/20 text-amber-300'}`}>
                {e.action === 'locked' ? <Lock className="w-2 h-2" /> : <Unlock className="w-2 h-2" />}
              </span>
              <div className="text-slate-200">
                <b className={e.action === 'locked' ? 'text-emerald-300' : 'text-amber-300'}>{e.action === 'locked' ? 'Locked' : 'Unlocked'}</b> {e.start_date} → {e.end_date} by <b>{e.by_name}</b>
                <span className="text-slate-500"> · {when(e.at)}</span>
                <span className="text-slate-500"> · {e.source === 'period' ? 'period lock' : e.source === 'entries' ? `${e.entries ?? 0} entr${e.entries === 1 ? 'y' : 'ies'}${e.skipped ? `, ${e.skipped} skipped` : ''}` : `${e.entries ?? 0} entr${e.entries === 1 ? 'y' : 'ies'} + period lock`}</span>
              </div>
              {e.reason && <div className="text-slate-400 italic">"{e.reason}"</div>}
            </li>
          ))}
        </ol>
      )}
    </div>
  );
};

export default LockHistory;
